import store from "../../store";

export default function(lookupType) {

    if (lookupType.includes("+")) lookupType = lookupType.replace(/\+/g, "%2B");

    if (!store.state.lookups.lookups[lookupType]) {
        store.dispatch("lookups/load", lookupType);
    } 

    let lookup = {};
    lookup.value = val => {
        if (val === null) return null;
        if (store.state.lookups.lookups[lookupType]) {
            let matchPredicate = _.isString(val) ? {name: val} : { id: val };
            var lookupItem = _.find(store.state.lookups.lookups[lookupType], matchPredicate);
            if (lookupItem) return lookupItem.description;
            console.error(`Item not found ${lookupType} ${val}`);
            return null;
        }
    };

    lookup.all = () => {
        return store.state.lookups.lookups[lookupType] || [];
    };

    return lookup;
}



// WEBPACK FOOTER //
// ./src/framework/utils/lookup.js